module.exports = __webpack_public_path__ + "img/img54.113c0c6b.png";